<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Mail" class="d-icon d-icon--mail" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12"><path fill="currentColor" fill-rule="evenodd" d="M2.5 2.5A.5.5 0 0 0 2 3v.225l4.252 2.702a.47.47 0 0 0 .496 0h.002L11 3.224V3a.5.5 0 0 0-.5-.5h-8Zm9.5.992V3a1.5 1.5 0 0 0-1.5-1.5h-8A1.5 1.5 0 0 0 1 3v6a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 12 9V3.492Zm-1 .918L7.28 6.774a1.47 1.47 0 0 1-1.56 0l-.003-.002L2 4.41V9a.5.5 0 0 0 .5.5h8A.5.5 0 0 0 11 9V4.41Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMail',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
